import React, { useState } from "react";
import { ChevronDownIcon, ChevronRightIcon } from "@radix-ui/react-icons";
import { CopyButton } from "./ui/copy-button";

interface ThinkingAccordionProps {
  value?: string;
  id: string | number;
  defaultOpen?: boolean;
  className?: string;
  title?: string;
  children?: React.ReactNode;
  copyValue?: string;
}

const ThinkingAccordion: React.FC<ThinkingAccordionProps> = ({
  value,
  id,
  defaultOpen = false,
  className = "",
  title = "Thinking",
  children,
  copyValue,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  if (!value && !children) return null;

  return (
    <div
      className={`mb-2 w-full rounded-md border border-gray-200 bg-gray-100 text-gray-900 shadow-sm ${className}`}
    >
      <button
        className={`flex w-full items-center ${
          open ? "rounded-t-md" : "rounded-md"
        } border-b border-gray-200 bg-gray-200 py-2 text-left text-sm font-medium transition hover:bg-gray-300`}
        onClick={() => setOpen((v) => !v)}
        type="button"
        aria-expanded={open}
        aria-controls={`thinking-content-${id}`}
      >
        {open ? (
          <ChevronDownIcon className="ml-1 mr-2 inline h-4 w-4" />
        ) : (
          <ChevronRightIcon className="ml-1 mr-2 inline h-4 w-4" />
        )}
        <span>{title}</span>
      </button>
      {open && (
        <div
          id={`thinking-content-${id}`}
          className="flex justify-between rounded-b-md bg-slate-50 px-2 py-2"
        >
          <div className="w-full whitespace-pre-wrap pr-4 text-gray-800">
            {children ? children : value}
          </div>
          <div>
            <CopyButton
              text={
                copyValue ??
                value ??
                (typeof children === "string" ? children : "")
              }
              title={`Copy ${title}`}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ThinkingAccordion;
